

$(document).ready(function () {
    $('.dynamicPageContainer .sectionHeading').each(function () {
        const text = $(this).text();
        if (text === '{callout-styles}') {
            $(this).parent().addClass('calloutStyles');
            $(this).remove();
        }
    })
})



